import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logoSmartKood from "assets/img/logo-smartkood.png";
import Sidebar, { getVisibleMenuItems } from "components/layout/Sidebar";
import Navbar from "components/layout/Navbar";
import NoAccessPage from "components/layout/NoAccessPage";
import AccessRoute from "components/routing/AccessRoute";
import { ACCESS } from "lib/constants/access-keys";
import CreditTransferPage from "modules/credit-transfer/pages/credit-transfer.page";
import TransferHistoryPage from "modules/transfer-history/pages/transfer-history.page";
import NotificationSettingsPage from "modules/notification-settings/pages/notification-settings.page";

const DRAWER_WIDTH = 248;

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", minHeight: "100vh" },
  contentWrapper: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: 56,
    minHeight: "calc(100vh - 56px)",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#EBEDEE",
  },
  footer: {
    height: 66,
    backgroundColor: "#fff",
    boxShadow: "0px -1px 0px 0px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 24px",
  },
  footerRight: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  footerPowered: {
    fontSize: 11,
    fontWeight: 400,
    color: "#899498",
  },
  footerLogo: {
    height: 20,
    objectFit: "contain",
  },
}));

export default function PortalLayout() {
  const classes = useStyles();
  const userAccess = useSelector((state) => state.session.user?.access ?? []);
  const visibleItems = getVisibleMenuItems(userAccess);
  const firstItem = visibleItems[0];
  const landingPath = firstItem
    ? (firstItem.path || firstItem.children?.[0]?.path || "/portal/no-access")
    : "/portal/no-access";
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className={classes.root}>
      <Navbar drawerWidth={DRAWER_WIDTH} onToggleSidebar={() => setSidebarOpen((open) => !open)} />
      <Sidebar drawerWidth={DRAWER_WIDTH} open={sidebarOpen} />
      <div className={classes.contentWrapper}>
        <main className={classes.content}>
          <Switch>
            <AccessRoute exact path="/portal/credit-transfer" requires={ACCESS.CREDIT_TRANSFER}>
              <CreditTransferPage />
            </AccessRoute>
            <AccessRoute exact path="/portal/transfer-history" requires={ACCESS.CREDIT_TRANSFER}>
              <TransferHistoryPage />
            </AccessRoute>
            <Redirect exact from="/portal/action-log" to="/portal/transfer-history" />
            <AccessRoute exact path="/portal/notification-settings" requires={ACCESS.CREDIT_TRANSFER}>
              <NotificationSettingsPage />
            </AccessRoute>
            <Route exact path="/portal/no-access" component={NoAccessPage} />
            <Redirect exact from="/portal" to={landingPath} />
          </Switch>
        </main>
        <Box className={classes.footer}>
          <Box className={classes.footerRight}>
            <Typography className={classes.footerPowered}>Powered by</Typography>
            <img src={logoSmartKood} alt="SmartKood" className={classes.footerLogo} />
          </Box>
        </Box>
      </div>
    </div>
  );
}
